<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
  <div class="flex flex-row items-center">
    <h2
      mat-dialog-title
      class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color"
    >
      {{ this.heading }}
    </h2>
  </div>
  <button
    mat-icon-button
    class="dialog-close-btn flex items-center justify-center"
    mat-dialog-close
  >
    <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div class="w-full">
    <div *ngIf="_data?.icon" class="w-fit mx-auto">
      <mat-icon
        class="!w-[100px] !h-[100px] !text-[100px] !text-blue-theme-color"
        >info</mat-icon
      >
    </div>

    <p
      *ngIf="_data?.type == 'cashCollection'"
      class="text-base leading-5 text-input-color font-medium text-justify"
    >
      {{ this.infoMessage | titlecase }}
    </p>
    <p
      *ngIf="_data?.type == 'order'"
      class="text-base leading-5 text-input-color font-medium text-justify"
    >
      {{ this.infoMessage | titlecase }}
    </p>
    <div
      class="infoMessage text-lg"
      *ngIf="_data?.type == 'terms' || _data?.type == 'policy'"
      [innerHtml]="this.infoMessage"
    ></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  *ngIf="_data?.type != 'html'"
  class="mt-2 !pb-5 !px-0 justify-center"
>
  <button
    color="primary"
    mat-dialog-close
    class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color"
    mat-flat-button
  >
    {{ "OK" }}
  </button>
</mat-dialog-actions>
